module.exports = __webpack_public_path__ + "static/flags/PK-0e6531b1405d6630ad68b3b232a98127.gif";